import { Observable } from 'rxjs';
import type { IdsExpression } from '@trackback/widgets';
import { createNoArgsObservableNamedExpressionResolver } from '../types';

export const createIdsResolver = (ids$: Observable<string[]>) =>
  createNoArgsObservableNamedExpressionResolver<IdsExpression>('ids', ids$);
